import { nanoid } from "@reduxjs/toolkit";

export const servicesOptions = [
  { id: nanoid(), value: 28955, label: "Automotive Services" },
  { id: nanoid(), value: 28956, label: "Beauty Services" },
  { id: nanoid(), value: 28957, label: "Catering and Food Services" },
  { id: nanoid(), value: 28958, label: "Child and Elderly Care" },
  { id: nanoid(), value: 28959, label: "Computer and Tech Services" },
  { id: nanoid(), value: 28960, label: "Construction and Remodeling" },
  { id: nanoid(), value: 28961, label: "Consultation and Coaching" },
  { id: nanoid(), value: 28962, label: "Creative and Design Services" },
  { id: nanoid(), value: 28963, label: "Education and Tutoring"},
  { id: nanoid(), value: 28964, label: "Entertainment and Performance"},
  { id: nanoid(), value: 28965, label: "Event and Party Services"},
  { id: nanoid(), value: 28966, label: "Financial and Legal Services"},
  { id: nanoid(), value: 28967, label: "Health and Wellness Services"},
  { id: nanoid(), value: 28968, label: "Home Cleaning and Maintenance"},
  { id: nanoid(), value: 28969, label: "Landscaping and Gardening"},
  { id: nanoid(), value: 28970, label: "Moving and Storage"},
  { id: nanoid(), value: 28977, label: "Other"},
  { id: nanoid(), value: 28971, label: "Pet Services"},
  { id: nanoid(), value: 28972, label: "Photography and Videography"},
  { id: nanoid(), value: 28973, label: "Real Estate Services"},
  { id: nanoid(), value: 28974, label: "Repair and Maintenance"},
  { id: nanoid(), value: 28975, label: "Travel and Vacation Services"},
  { id: nanoid(), value: 28976, label: "Writing, Translation, and Transcription"},
];

export const availableTimesOptions = [
  { id: nanoid(), value: "Afternoon", label: "Afternoon" },
  { id: nanoid(), value: "Evening", label: "Evening" },
  { id: nanoid(), value: "Morning", label: "Morning" },
  { id: nanoid(), value: "Overnight", label: "Overnight" },
  { id: nanoid(), value: "Weekdays", label: "Weekdays" },
  { id: nanoid(), value: "Weekend", label: "Weekend" },
];

export const perPageOptions = [
  { id: nanoid(), value: 12, label: 12 },
  { id: nanoid(), value: 24, label: 24 },
  { id: nanoid(), value: 36, label: 36 },
  { id: nanoid(), value: 48, label: 48 },
  { id: nanoid(), value: 96, label: 96 },
];

export const sortByOptions = [
  { id: nanoid(), value: "Closest to Me", label: "Closest to Me" },
  { id: nanoid(), value: "Recently Posted", label: "Recently Posted" },
  { id: nanoid(), value: "Price (low-high)", label: "Price (low-high)" },
  { id: nanoid(), value: "Price (high-low)", label: "Price (high-low)" },
];

export const noResultsMessage = "No Search Results Found!";
export const endOfListMessage =
  "Looks like you've reached the end of the listings! To find exactly what you're looking for, try refining your search with the filters. Happy searching on FinditZ! ✨";
